module.exports = __webpack_public_path__ + "img/notekids.683e14a2.png";